// @flow
import { ACTIONS } from './constants';

export default function reactionsList(state: any = [], action: any = {}) {
    if (action.type === ACTIONS.LOAD_REACTIONS) {
        return action.reactions.map((reaction: any) => {
            return reaction.reactionId;
        });
    }

    return state;
}



// WEBPACK FOOTER //
// ./src/v5/messaging/state/reactionsListReducer.js